export const hasNumbers = (t: string): boolean => {
  const regex = /\d/g;
  return regex.test(t);
};

export const hasOnlyLettersAndSpaces = (str: string): boolean => {
  const regex = /^[а-яА-ЯёЁa-zA-Z\-\s]*$/;
  return regex.test(str);
};
